import type { JSX } from 'react';
import { BRAND } from '../config/content';

import styles from './Nav.module.css';

/**
 * The bar above the hero: the mark and the wordmark.
 *
 * No navigation links. There is nowhere else to go — the site is one page and the product does
 * not exist yet — so a nav full of anchors to nothing would be an invitation to a dead end. No
 * ground switch either: the page follows the device (REQ-LANDING-012).
 */
export function Nav(): JSX.Element {
  return (
    <nav className={styles.nav}>
      <span className={styles.brand}>
        <span className={styles.mark} aria-hidden="true" />
        <span className={styles.wordmark}>{BRAND.wordmark}</span>
      </span>
    </nav>
  );
}
